import "./Tuyendung.css";
export default function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="kw">Tìm việc làm · Việc làm 24h · Việc làm online · Tìm việc nhanh · Tuyển dụng việc làm · Tư vấn viên telesale</div>
        <div className="copy">© 2026 Tuyển Dụng Tư Vấn Viên. Landing page cho chiến dịch quảng cáo Google.</div>
      </div>
    </footer>
  );
}